/** @format */

import {Box, Stack} from '@mui/material';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import {Trans} from 'react-i18next';

import {useNavigate} from 'react-router-dom';

import Breadcrumbs from 'components/Breadcrumbs';

import {AccountsCompanyMediaplanType} from 'graphql/generated/types';

import {Title} from '../../styles';
import {ProjectType} from '../ProjectType';
import {CustomChip, Description, Header, ProjectButton} from './styles';
import {CHIPS} from './constants';
import {OauthProviderTokenDtoFromQuery} from '../../types/common';

interface Props {
  companyName: string;
  breadcrumbs: {
    href: string;
    title: React.ReactNode;
  }[];
  companyId: string;
  mediaplanType?: AccountsCompanyMediaplanType | null;
  tokens: OauthProviderTokenDtoFromQuery;
}

const NewProjectState = ({companyName, breadcrumbs, companyId, mediaplanType, tokens}: Props) => {
  const navigate = useNavigate();

  const handleProjectEdit = () => {
    navigate(`/home/project/edit?companyId=${companyId}`);
  };

  return (
    <Box>
      <Box sx={{mt: 4, mb: 8}}>
        <Breadcrumbs items={breadcrumbs} />
      </Box>

      <Header>
        <Box sx={{display: 'flex', alignItems: 'baseline', gap: 4}}>
          <Title>{companyName}</Title>
          {mediaplanType && <ProjectType mediaplanType={mediaplanType} tokens={tokens} />}
        </Box>
      </Header>

      <ProjectButton variant='contained' onClick={handleProjectEdit}>
        <EditOutlinedIcon fontSize='small' htmlColor='#fff' sx={{marginRight: '4px'}} />
        <Trans>Настроить проект</Trans>
      </ProjectButton>

      <Description>
        <Trans>Настройте проект, чтобы все модули стали доступны</Trans>
      </Description>

      <Stack direction='row' sx={{flexWrap: 'wrap'}}>
        {CHIPS.map(({label, variant}) => (
          <CustomChip key={label} label={label} variant={variant} />
        ))}
      </Stack>
    </Box>
  );
};

export default NewProjectState;
